import type { CustomerAgentStatus } from '../types/conversations.types';

/* Os textos da faixa de estado do Atendente IA (design D20, `CustomerAgentStatusBar`). */

export interface CustomerAgentStatusNotice {
  state: string;
  text: string;
  link: { to: string; label: string } | null;
}

/** O aviso do estado, ou nulo nos estados que não aparecem nesta faixa. */
export function customerAgentStatusNotice(status: CustomerAgentStatus | undefined): CustomerAgentStatusNotice | null {
  switch (status?.state) {
    case 'suspended_by_vapt':
      return {
        state: status.state,
        text: 'O Atendente IA foi pausado pela equipe do Vapt Menu. As mensagens continuam chegando no WhatsApp do celular.',
        link: null,
      };
    case 'provider_unavailable':
      return {
        state: status.state,
        text: 'O Atendente IA está fora do ar agora. As conversas novas vão para a equipe no Atendimento.',
        link: { to: '/conversations', label: 'Ver conversas' },
      };
    case 'budget_exceeded':
      return {
        state: status.state,
        text: 'O Atendente IA atingiu o limite de uso deste mês e parou de responder. Fale com o suporte do Vapt Menu.',
        link: null,
      };
    default:
      return null;
  }
}
